import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapsComponent from '../GoogleMapsComponent';
import SelectBusinessOption from '../SelectBusinessOption';
import TimerMixin from 'react-timer-mixin';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

export default class BusinessSearchComponent extends GoogleMapsComponent {
  state = {
    autoCompleteService: null,
    placesService: null,
    googleMaps: null,
    latestQueryString: null,
    searchResults: {},
    placeholderText: 'Enter your store name to view products'
  };

  static propTypes = {
    onBusinessSelected: PropTypes.func,
    onQueryChanged: PropTypes.func,
    onFocus: PropTypes.func,
    onOptionsOpen: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.handleGetOptions = this.handleGetOptions.bind(this);
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnOptionsOpen = this.handleOnOptionsOpen.bind(this);
    this.handleOnOptionsClose = this.handleOnOptionsClose.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.renderOption = this.renderOption.bind(this);
    this.filterOption = this.filterOption.bind(this);
    this.focus = this.focus.bind(this);

    this.onResults = this.onResults.bind(this);
    this.onPredictionsResults = this.onPredictionsResults.bind(this);
    this.onTextSearchResults = this.onTextSearchResults.bind(this);
  }

  focus() {
    // TODO: Re-implement or fix Select.Async component to fix all comments on this function.

    // Ugly hack. This needs to go.
    //document.getElementsByTagName('input')[0].focus();

    // This should work, once the Select.Async class is recreated.
    //this.refs.businessSearchInput.focus();
  }

  handleOnFocus() {
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  }

  handleOnOptionsOpen() {
    this.setState({placeholderText: ''});
  }

  handleOnOptionsClose() {
    this.setState({placeholderText: 'Enter your store name to view products'});
  }

  handleOnBlur() {
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  }

  // Google Maps has loaded and we can initialize our input
  handleApiLoaded(googleMaps) {
    let resultDiv = document.createElement('result-div');
    let placesService = new googleMaps.places.PlacesService(resultDiv);
    let autoCompleteService = new googleMaps.places.AutocompleteService();

    this.setState({
      autoCompleteService: autoCompleteService,
      placesService: placesService,
      googleMaps: googleMaps
    });
  }

  handleGetOptions(input, placesCallback) {
    if (input.length < 4) { // We don't search with less than 4 letters
      placesCallback(input, { options: [], complete: false });
      return;
    }

    // Save the current query string. Once the function executes, if the query is still the same
    // then we fire a Google Places query.
    let searchResults = this.state.searchResults;
    searchResults[input] = { total: 0, places: {} };
    this.setState({ latestQueryString: input });

    // Search with autoComplete APIs.
    setTimeout(
      () => {
        this.autoCompleteSearch(input, placesCallback);
      },
      250
    );

    // Search with text search APIs.
    setTimeout(
      () => {
        this.textSearch(input, placesCallback);
      },
      250
    );
  }

  autoCompleteSearch(input, placesCallback) {
    if (this.state.latestQueryString !== input) {
      // User has changed the search query, no need to search on Google Places yet.
      this.onResults(placesCallback, input, {});
      return;
    }

    let service = this.state.autoCompleteService;

    let autocompletePlacesRequest = {
      input: input,
      componentRestrictions: {country: 'US'},
      types: ['establishment']
    };
    service.getPlacePredictions(
      autocompletePlacesRequest,
      (predictions, status) => {
        this.onPredictionsResults(placesCallback, input, predictions, status);
      }
    );

    let autocompleteQueryRequest = {
      input: input,
      componentRestrictions: {country: 'US|CA'}
    };
    service.getQueryPredictions(
      autocompleteQueryRequest,
      (predictions, status) => {
        this.onPredictionsResults(placesCallback, input, predictions, status);
      }
    );
  }

  textSearch(input, placesCallback) {
    if (this.state.latestQueryString !== input) {
      // User has changed the search query, no need to search on Google Places yet.
      this.onResults(placesCallback, input, {});
      return;
    }

    let service = this.state.placesService;
    let textSearchRequest = {
      query: input,
      type: 'store' // We only want to find stores!
    };

    service.textSearch(
      textSearchRequest,
      (places, status, pagination) => {
        this.onTextSearchResults(placesCallback, input, places, status, pagination);
      }
    );
  }

  onPredictionsResults(placesCallback, input, predictions, status) {
    if (status !== "OK") {
      this.onResults(placesCallback, input, {});
      return;
    }

    let options = {};
    predictions.forEach(function(prediction) {
      if (!prediction.place_id || !prediction.structured_formatting.secondary_text) {
        return;
      }

      let name = prediction.structured_formatting.main_text;
      let address = prediction.structured_formatting.secondary_text;
      let lastComma = address.lastIndexOf(',');
      let country = address.substring(lastComma + 2, address.length);
      address = address.substring(0, lastComma);
      let newPlace = {
        placeId: prediction.place_id,
        name: name,
        types: [],
        address: address,
        country: country
      };
      options[newPlace.placeId] = newPlace;
    });

    this.onResults(placesCallback, input, options);
  }

  onTextSearchResults(placesCallback, input, places, status, pagination) {
    if (status !== "OK") {
      this.onResults(placesCallback, input, {});
      return;
    }

    let options = {};
    places.forEach(function(place) {
      let address = place.formatted_address;
      let lastComma = address.lastIndexOf(',');
      let country = address.substring(lastComma + 2, address.length);
      address = address.substring(0, lastComma);
      let newPlace = {
        placeId: place.place_id,
        name: place.name,
        types: place.types,
        address: address,
        country: country
      };
      options[newPlace.placeId] = newPlace;
    });

    this.onResults(placesCallback, input, options);
  }

  onResults(placesCallback, input, options) {
    let onQueryChanged = this.props.onQueryChanged;
    let searchResults = this.state.searchResults[input] || { total: 0, places: {} };

    searchResults.total++;

    let placeIds = Object.keys(options);
    placeIds.forEach(function(placeId) {
      searchResults.places[placeId] = options[placeId];
    });

    if (searchResults.total === 3) {
      if (onQueryChanged !== null) onQueryChanged(input);

      let allFoundStores = [];
      let allPlaceIds = Object.keys(searchResults.places);
      allPlaceIds.forEach(
        placeId => {
          allFoundStores.push(searchResults.places[placeId]);
        }
      );
      // Add the hint item.
      allFoundStores.push({hintItem: true, disabled: true});
      placesCallback(input, {options: allFoundStores, complete: false});
    }
  }

  /** The user has selected a business. */
  handleSearchChange(place) {
    if (place == null) return;
    let onBusinessSelected = this.props.onBusinessSelected;

    let placesService = this.state.placesService;
    let googleMaps = this.state.googleMaps;
    placesService.getDetails({ placeId: place.placeId }, function(placeDetails, status) {
      if (status === googleMaps.places.PlacesServiceStatus.OK) {
        if (onBusinessSelected !== null) {
          onBusinessSelected(placeDetails);
        }
      }
    });
  }

  filterOption(place) {
    if (place.hintItem) return true;

    if (place.country.toLowerCase() !== 'united states'
        && place.country.toLowerCase() !== 'canada') {
        return false;
    }

    let excluded = false;
    let totalTypes = place.types.length;
    let excludedTypes = [];
    for (let i = 0; i < totalTypes; i++) {
      let placeType = place.types[i];
      if (placeType in window.includedBusinessTypes) {
        return true;
      }
      if (placeType in window.excludedBusinessTypes) {
        excludedTypes.push(placeType);
        excluded = true;
      }
    }

    if (excluded) {
      return false;
    }
    return true;
  }

  renderOption(place) {
    return (
      <SelectBusinessOption
        googlePlaceSearchItem={place}
      />
    );
  }

  render() {
    let placesService = this.state.placesService;
    if (placesService == null) return null;

    return <Select.Async
              loadOptions={this.handleGetOptions}
              ref={this.props.id}
              id={this.props.id}
              onFocus={this.handleOnFocus}
              onOpen={this.handleOnOptionsOpen}
              onClose={this.handleOnOptionsClose}
              onBlur={this.handleOnBlur}
              onChange={this.handleSearchChange}
              optionRenderer={this.renderOption}
              filterOption={this.filterOption}
              clearable={true}
              autoBlur={true}
              autofocus={this.props.autofocus || false}
              autoload={false}
              autosize={true}
              multi={false}
              cache={false}
              tabSelectsValue={false}
              placeholder={this.state.placeholderText}
              searchPromptText={'Start typing the name of your store'}
              noResultsText={'Store not found. Try typing your store name and the city'}
    />
  }
}

BusinessSearchComponent.mixins = [TimerMixin];



/** WEBPACK FOOTER **
 ** ./src/components/BusinessSearchComponent/index.js
 **/